import { STORES_API } from 'modules/stores/api/stores-api'
import { StoreId } from 'modules/stores/types/stores-interface'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { OptinItemViewType } from '../../types/optin-interface'

export const useStoreOptinItemsList = (storeId?: StoreId, shouldFetch?: boolean) => {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, OptinItemViewType[]>({
    method: RequestMethodsEnum.get,
  })

  return useControlledSwr(
    () => !!storeId && `${STORES_API}/${storeId}/item-opt-ins/choice-list-tmp`,
    fetcher,
    {},
    Boolean(user && shouldFetch),
  )
}
